import { render, staticRenderFns } from "./GroupsImporter.vue?vue&type=template&id=c177f036&scoped=true&"
import script from "./GroupsImporter.vue?vue&type=script&lang=js&"
export * from "./GroupsImporter.vue?vue&type=script&lang=js&"
import style0 from "./GroupsImporter.vue?vue&type=style&index=0&id=c177f036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c177f036",
  null
  
)

export default component.exports